import { createFileRoute } from '@tanstack/react-router';

import { CrochetViewerPage } from '@/pages/crochet-viewer/crochet-viewer-page';

export const Route = createFileRoute('/crochet/$diagramId_/view')({
    component: CrochetViewerRoute,
    // The properties column owns the account corner; the page-level
    // header tray owns the app-nav corner on desktop.
    staticData: { ownTopLeft: true, ownTopRight: true },
});

function CrochetViewerRoute() {
    const { diagramId } = Route.useParams();
    return <CrochetViewerPage diagramId={diagramId} />;
}
